



import { HttpHeaders } from "@angular/common/http";

export class BaseService {

    protected getHttpOptions (authenticated: boolean, params?: URLSearchParams) {
        if (authenticated) {
            const headers = new HttpHeaders({
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('authToken'),
            });
            return { headers };
        }
        else {
            let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
            return (params != null) ? { headers, search: params } : { headers };
        }
    }

}
